<template>
  <div>

    <p>Lekarstwa
      <el-button type="primary" @click="dialogVisible = true">Dodaj lek</el-button>
    </p>
    <template>
      <el-table :data="drugs" style="width: 100%" stripe>
        <el-table-column prop="name" label="Nazwa lekarstwa" sortable>
        </el-table-column>
        <el-table-column prop="description" label="Opis">
        </el-table-column>
        <el-table-column label="Opcje">
          <template slot-scope="scope">
            <el-button @click.native.prevent="deleteDrug(scope.$index, drugs)" type="text" size="small">
              Usuń
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </template>


    <el-dialog title="Dodaj lekarstwo" :visible.sync="dialogVisible" size="tiny">
      <span>

        <span class="my-label">Nazwa</span>
        <el-input placeholder="Nazwa leku" v-model="drug.name"></el-input>
        <span class="my-label">Opis</span>
        <el-input placeholder="Opis leku" type="textarea" :rows="2" v-model="drug.description"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button type="primary" @click="dialogVisible = false, addDrug()">Dodaj</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { serverAddress } from "../config";
export default {
  mounted: function() {
    this.getDrugs("/api/drugs");
  },
  data: function() {
    return {
      drugs: [],
      drug: {
        name: "",
        description: ""
      },
      dialogVisible: false
    };
  },
  methods: {
    handleCurrentChange(value) {
      this.currentRow = value;
    },
    getDrugs(url) {
      axios
        .get(serverAddress + url, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.drugs = response.data;
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },

    deleteDrug(index, rows) {
      axios
        .delete(serverAddress + "/api/drugs/" + rows[index].name, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            rows.splice(index, 1);

            console.log(response);

            this.$message({
              message: "Pomyślnie usunięto lek",
              type: "success"
            });
          }.bind(this)
        )
        .catch(
          function(error) {
            console.log(error);
            this.$message({
              message: "Błąd usuwania leku",
              type: "error"
            });
          }.bind(this)
        );
    },
    addDrug() {
      axios
        .post(serverAddress + "/api/drugs", this.drug, {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            console.log(response);
            this.drugs.push(this.drug);

            (this.drug = {
              name: "",
              description: ""
            }),
              this.$message({
                message: "Pomyślnie zapisano lek",
                type: "success"
              });
          }.bind(this)
        )
        .catch(
          function(error) {
            this.$message({
              message: "Błąd zapisu leku",
              type: "error"
            });

            console.log(error);
          }.bind(this)
        );
    }
  },
  deleteRow(index, rows) {
    rows.splice(index, 1);
  }
};
</script>

<style>

</style>
